<template>
  <div>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-row class="mb-2">
          <b-col
            md="4"
          >
            <label for="states">Search by state</label>
            <v-select
              id="states"
              v-model="queryFilter.status"
              :clearable="false"
              placeholder="No state selected"
              label="label"
              :options="statusOptions"
              :reduce="(option) => option.key"
              @input="fetchDriversLocation"
            />
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <label for="zones">Search by zone</label>
            <v-select
              id="zones"
              v-model="queryFilter.zone"
              :clearable="false"
              placeholder="No zone selected"
              label="city"
              :options="zones"
              :reduce="(option) => option.city"
              @input="fetchDriversLocation"
            />
          </b-col>
          <b-col
            md="4"
            class="d-flex justify-content-end align-items-center"
          >
            <b-button
              variant="primary"
              @click="fetchDriversLocation"
            >
              Refresh locations
            </b-button>
          </b-col>
          <b-col md="4">
            <label>Search By Driver ID</label>
            <b-form-input
              v-model="driverID"
              placeholder="Driver ID"
              clearable
            />
          </b-col>
          <b-col
            md="4"
            class="d-flex align-items-center mt-1"
          >
            <b-button
              variant="primary"
              @click="fetchDriversLocation"
            >
              Search By Driver ID
            </b-button>
            <b-button
              variant="outline-primary"
              class="ml-1"
              @click="onClear"
            >
              Clear Driver ID
            </b-button>
          </b-col>
        </b-row>
        <map-view
          v-if="!loading && locations.length"
          :locations="locations"
        />
        <h3
          v-if="!loading && !locations.length"
          class="text-center mt-5"
        >
          No drivers found
        </h3>
      </b-overlay>
    </b-card>

  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BOverlay, BButton, BFormInput,
} from 'bootstrap-vue'
import { ref, reactive } from '@vue/composition-api'
import vSelect from 'vue-select'
import MapView from './map-view.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import driversStore from '../driverStoreModule'
import zoneStoreModule from '@/views/zones/zoneStoreModule'

export default {
  components: {
    BCard,
    MapView,
    BRow,
    BCol,
    vSelect,
    BOverlay,
    BButton,
    BFormInput,
  },
  setup(_, { root }) {
    const statusOptions = [
      {
        label: 'Occupied',
        key: 'OCCUPIED',
      },
      {
        label: 'Available',
        key: 'AVAILABLE',
      },
      {
        label: 'Unavailable',
        key: 'UNAVAILABLE',
      },
    ]
    useRegisterStoreModule('drivers', driversStore)
    useRegisterStoreModule('zones', zoneStoreModule)
    const driverID = ref(null)
    const locations = ref(null)
    const queryFilter = reactive({
      status: 'AVAILABLE',
      zone: undefined,
    })
    const loading = ref(false)
    const fetchDriversLocation = async () => {
      let queryFilterTemp = {}
      if (driverID.value) {
        queryFilterTemp.driver_id = driverID.value
      } else {
        queryFilterTemp = { ...queryFilter }
      }
      loading.value = true
      const res = await root.$store.dispatch('drivers/fetchDriversLocation', queryFilterTemp)
      locations.value = res.data.data.result.items
      loading.value = false
    }
    const onClear = () => {
      driverID.value = null
      fetchDriversLocation()
    }
    const zones = ref([])
    const fetchZones = async () => {
      const result = await root.$store.dispatch('zones/fetchZones')
      zones.value = result
      const ammanZone = zones.value.filter(el => el.city === 'Amman')
      queryFilter.zone = ammanZone[0].city
    }

    const init = async () => {
      loading.value = true
      await fetchZones()
      fetchDriversLocation()
    }
    init()
    return {
      onClear,
      locations,
      statusOptions,
      queryFilter,
      fetchDriversLocation,
      loading,
      zones,
      driverID,
    }
  },
}
</script>

<style>

</style>
